import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import { getOneLog, deleteGameLog } from "../../services/gameLog.services";
import { GeneratePlayerStats } from "./helper";
import "./gamelogdetails.css";
import DownloadFilesOverlay from "../../UserComponents/overlays/DownloadFilesOverlay.js";
import jsPDF from "jspdf";
import domtoimage from "dom-to-image";

import DeleteOverlay from "../../UserComponents/overlays/DeleteOverlay";
import SuccessOverlay from "../../UserComponents/overlays/SuccessOverlay";

import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";

const GameLogDetails = (props) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [delIsVisible, setDelIsVisible] = useState(false);
  const [delSuccessVisible, setDelSuccessVisible] = useState(false);
  const [activityState, setActivityState] = useState([]);
  const [visible, setVisible] = useState(false);
  const [gameLogVisible, setGameLogVisible] = useState(false);
  const [gameSummaryVisible, setGameSummaryVisible] = useState(false);
  const [playerSummaryVisible, setPlayerSummaryVisible] = useState(false);
  const [downloadFilesVisible, setDownloadFilesVisible] = useState(false);
  const [data, setData] = useState(null);
  const [playedIngameFilteredPlayers, setPlayedIngameFilteredPlayers] =
    useState(null);
  const [isOverlayVisible, setOverlayVisible] = useState(false);
  const [activeView, setActiveView] = useState(null);

  const [isNoneStatsA, setIsNoneStatsA] = useState(false);
  const [isNoneStatsB, setIsNoneStatsB] = useState(false);

  const user = useSelector((state) => state.auth.user);
  const operatorTeam = useSelector((state) => state.team.selectedTeam);
  // const general = useSelector((state) => state.clockStatsOnlyReducer.general);
  const history = useHistory();
  const { logId } = useParams();

  const A = data?.teamA;
  const A1 = A?.qtrStats ? A.qtrStats?.quarter1 : A?.periodStats?.period1;
  const A2 = A?.qtrStats ? A.qtrStats?.quarter2 : A?.periodStats?.period2;
  const A3 = A?.qtrStats ? A.qtrStats?.quarter3 : A?.periodStats?.period3;
  const A4 = A?.qtrStats ? A.qtrStats?.quarter4 : A?.periodStats?.period4;

  const B = data?.teamB;
  const B1 = B?.qtrStats ? B.qtrStats?.quarter1 : B?.periodStats?.period1;
  const B2 = B?.qtrStats ? B.qtrStats?.quarter2 : B?.periodStats?.period2;
  const B3 = B?.qtrStats ? B.qtrStats?.quarter3 : B?.periodStats?.period3;
  const B4 = B?.qtrStats ? B.qtrStats?.quarter4 : B?.periodStats?.period4;

  let { teamAplayerStats, teamBplayerStats } = GeneratePlayerStats(data);

  const sections = {
    Scoring: ["Goals", "ASST", "TS", "SOG"],
    Fielding: ["GB", "CT", "TO", "TA", "INT", "UE"],
    "Face Offs": ["FA", "FW", "FV", "FOGB"],
    "Goal Tending": ["Min", "SAVES", "SC", "SNC", "GA", "WON", "LOST", "TIE"],
  };

  const statMappings = {
    Goals: "goals",
    ASST: "assists",
    TS: "shotAttempts",
    SOG: "shotOG",
    GB: "groundBall",
    CT: "causedTurnover",
    TO: "turnOver",
    TA: "takeAway",
    INT: "interceptions",
    UE: "unforcedErrors",
    FA: "faceoffsAttempts",
    FW: "faceoffsWon",
    FV: "faceoffsViolation",
    FOGB: "faceoffGB",
    Min: "minutesPlayed",
    SAVES: "saves",
    SC: "shotsConceded",
    SNC: "shotsOnNet",
    GA: "goalsAgainst",
    WON: "won",
    LOST: "lost",
    TIE: "tie",
  };

  const sumStat = (teamStats, statType) =>
    teamStats.reduce((total, player) => total + (player[statType] || 0), 0);

  const renderTable = (teamStats, sectionTitle, statTypes) => {
    const sortedTeamStats = [...teamStats].sort(
      (a, b) => (a.jersey || 0) - (b.jersey || 0)
    );
    let displayIdx = 0; // Track displayed row index separately

    return (
      <table key={sectionTitle} className="player-stats-table">
        <thead>
          <tr>
            <th>Jersey #</th>
            <th>Player</th>
            {statTypes.map((stat) => (
              <th key={stat}>{stat}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedTeamStats.map((player, idx) => {
            const hasStats = statTypes.some(
              (stat) => player[statMappings[stat]] !== undefined
            );
            if (!hasStats) return null;

            const rowStyle =
              displayIdx % 2 === 0
                ? { backgroundColor: "#e6e4e4" }
                : { backgroundColor: "#ffffff" };
            displayIdx++;

            return (
              <tr key={player.jersey || idx} style={rowStyle}>
                <td>{player.jersey || ""}</td>
                <td>{player.player || ""}</td>
                {statTypes.map((stat) => (
                  <td key={stat}>{player[statMappings[stat]] || 0}</td>
                ))}
              </tr>
            );
          })}
        </tbody>

        {/* Team total row */}
        <tfoot className="team-total">
          <tr className="totals-all">
            <td style={{ border: "none" }}></td>
            <td style={{ border: "none", color: "rgb(73, 141, 218)" }}>
              <strong>Team Totals: </strong>
            </td>
            {statTypes.map((stat) => (
              <td key={`total` - `${stat}`}>
                <strong>{sumStat(teamStats, statMappings[stat])}</strong>
              </td>
            ))}
          </tr>
        </tfoot>
      </table>
    );
  };

  const renderTableWithTotals = (teamStats) => {
    const sortedTeamStats = [...teamStats].sort(
      (a, b) => (a.jersey || 0) - (b.jersey || 0)
    );
    const getTotalsForAllSections = (teamStats, sections) => {
      const totalStats = {};

      Object.keys(sections).forEach((section) => {
        sections[section].forEach((stat) => {
          totalStats[stat] = teamStats.reduce(
            (total, player) => total + (player[statMappings[stat]] || 0),
            0
          );
        });
      });

      return totalStats;
    };

    const totals = getTotalsForAllSections(teamStats, sections);

    return (
      <table className="player-stats-table-combined">
        <thead>
          <tr>
            <th rowSpan="2">#</th>
            <th rowSpan="2">Name</th>
            {/* <th rowSpan="2">+/-</th> */}
            <th
              colSpan="4"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Scoring
            </th>
            <th
              colSpan="6"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Fielding
            </th>
            <th
              colSpan="4"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Face Offs
            </th>
            <th
              colSpan="8"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Goal Tending
            </th>
          </tr>
          <tr>
            {/* Scoring */}
            <th>Goals</th>
            <th>ASST</th>
            <th>TS</th>
            <th>SOG</th>

            {/* Fielding */}
            <th>GB</th>
            <th>CT</th>
            <th>TO</th>
            <th>TA</th>
            <th>INT</th>
            <th>UE</th>

            {/* Face Offs */}
            <th>FA</th>
            <th>FW</th>
            <th>FV</th>
            <th>FOGB</th>

            {/* Goal Tending */}
            <th>Min</th>
            <th>SAVES</th>
            <th>SC</th>
            <th>SNC</th>
            <th>GA</th>
            <th>WON</th>
            <th>LOST</th>
            <th>TIE</th>
          </tr>
        </thead>
        <tbody>
          {sortedTeamStats
            .filter((player) => player.jersey && player.player) // Filter out players with no jersey or name
            .map((player, idx) => (
              <tr key={idx}>
                <td>{player.jersey || ""}</td>
                <td>{player.player || ""}</td>

                {/* Scoring */}
                <td>{player.goals || 0}</td>
                <td>{player.assists || 0}</td>
                <td>{player.shotAttempts || 0}</td>
                <td>{player.shotOG || 0}</td>

                {/* Fielding */}
                <td>{player.groundBall || 0}</td>
                <td>{player.causedTurnover || 0}</td>
                <td>{player.turnOver || 0}</td>
                <td>{player.takeAway || 0}</td>
                <td>{player.interceptions || 0}</td>
                <td>{player.unforcedErrors || 0}</td>

                {/* Face Offs */}
                <td>{player.faceoffsAttempts || 0}</td>
                <td>{player.faceoffsWon || 0}</td>
                <td>{player.faceoffsViolation || 0}</td>
                <td>{player.faceoffGB || 0}</td>

                {/* Goal Tending */}
                <td>{player.minutesPlayed || 0}</td>
                <td>{player.saves || 0}</td>
                <td>{player.shotsConceded || 0}</td>
                <td>{player.shotsOnNet || 0}</td>
                <td>{player.goalsAgainst || 0}</td>
                <td>{player.won || 0}</td>
                <td>{player.lost || 0}</td>
                <td>{player.tie || 0}</td>
              </tr>
            ))}

          <tr>
            <th
              colSpan="6"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Scoring
            </th>
            <th
              colSpan="6"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Fielding
            </th>
            <th
              colSpan="4"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Face Offs
            </th>
            <th
              colSpan="8"
              className="section-heading"
              style={{ backgroundColor: "rgb(73, 141, 218)", color: "white" }}
            >
              Goal Tending
            </th>
          </tr>
          <tr>
            <td colSpan="2" className="totals-row">
              <strong>Team Totals</strong>
            </td>
            {/* colSpan="3" */}
            {/* Scoring Totals */}

            <td>
              <strong>{totals.Goals}</strong>
            </td>
            <td>
              <strong>{totals.ASST}</strong>
            </td>
            <td>
              <strong>{totals.TS}</strong>
            </td>
            <td>
              <strong>{totals.SOG}</strong>
            </td>

            {/* Fielding Totals */}
            <td>
              <strong>{totals.GB}</strong>
            </td>
            <td>
              <strong>{totals.CT}</strong>
            </td>
            <td>
              <strong>{totals.TO}</strong>
            </td>
            <td>
              <strong>{totals.TA}</strong>
            </td>
            <td>
              <strong>{totals.INT}</strong>
            </td>
            <td>
              <strong>{totals.UE}</strong>
            </td>

            {/* Face Offs Totals */}
            <td>
              <strong>{totals.FA}</strong>
            </td>
            <td>
              <strong>{totals.FW}</strong>
            </td>
            <td>
              <strong>{totals.FV}</strong>
            </td>
            <td>
              <strong>{totals.FOGB}</strong>
            </td>

            {/* Goal Tending Totals */}
            <td>
              <strong>{totals.Min}</strong>
            </td>
            <td>
              <strong>{totals.SAVES}</strong>
            </td>
            <td>
              <strong>{totals.SC}</strong>
            </td>
            <td>
              <strong>{totals.SNC}</strong>
            </td>
            <td>
              <strong>{totals.GA}</strong>
            </td>
            <td>
              <strong>{totals.WON}</strong>
            </td>
            <td>
              <strong>{totals.LOST}</strong>
            </td>
            <td>
              <strong>{totals.TIE}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  useEffect(() => {});

  useEffect(() => {
    console.log("GameLogDetails rendered with ID:", logId);
  }, [logId]);

  useEffect(() => {
    const fetchGameLogDetails = async () => {
      try {
        setLoading(true);
        const response = await getOneLog(logId, user?.token);
        console.log("API Response Data:", response.data); // Log the data
        setData(response.data);
      } catch (error) {
        console.error("ERROR in getOneLog:", error.message);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchGameLogDetails();
  }, [logId, user?.token]);

  const toggleFileDownload = () => {
    setDownloadFilesVisible(!downloadFilesVisible);
  };

  const downloadActivityLog = async () => {
    const dateX = moment(data.createdAt)
      .format("MM-D-YYYY, h:mm:ss a")
      .slice(0, 10);

    if (data) {
      try {
        // Step 1: Create a UUID-to-Sequence Map
        const uuidSequenceMap = {};
        let sequenceNumber = 1;

        const filteredActivityLog = data.activityLog.filter(
          (v) => v?.statement !== "Played In Game"
        );

        filteredActivityLog.forEach((obj) => {
          if (!uuidSequenceMap[obj.uuid]) {
            uuidSequenceMap[obj.uuid] = sequenceNumber++;
          }
        });

        const activityLogRows = filteredActivityLog.map((obj, index) => [
          obj.buttonPressed || "",
          uuidSequenceMap[obj.uuid], // Include UUID here
          index + 1,
          obj.team || "-",
          obj.jersey || "-1",
          obj.player || "Team Stat",
          obj.quarter || obj.period || "",
          obj.clockTime || "",
          obj.code || "",
          obj.statement || "",
          obj.rating || "",
          obj.addDesc || "",
          obj.cat || "",
          obj.pType || "",
          obj.pTime || "",
        ]);

        const playedIngameRows = playedIngameFilteredPlayers.map(
          (val, index) => [
            "",
            "",
            activityLogRows.length + index + 1, // Adjusting the index for playedIngameFilteredPlayers
            data.teamA.teamName || "",
            val.jersey || "",
            (val.playerName || "").split(" ").pop(),
            "E.O.G",
            "",
            "GP",
            "Played In Game",
            "",
            "",
            "Fielding",
          ]
        );

        const val = [
          [
            "Button Pressed",
            "Trans#", // Add UUID header
            "Seq#",
            "TEAM",
            "JER#",
            "NAME",
            "Qtr",
            "TIME",
            "CODE",
            "DESC",
            "Rating",
            "Additional Description",
            "CAT",
            "P-Type",
            "P-Time",
          ],
          ...activityLogRows,
          ...playedIngameRows,
        ];

        // Construct CSV string
        const headerString = "\n";
        const rowString = val.map((row) => row.join(",")).join("\n");

        const csvString = `${headerString}${rowString}`;

        // Create a Blob from the CSV string
        const blob = new Blob([csvString], { type: "text/csv" });

        // Create a link element to trigger the download
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = `${data.teamA.teamName}-gameLog(${dateX})-(${data.teamB.teamName}).csv`;

        // Append the link to the body and simulate a click to download
        document.body.appendChild(link);
        link.click();

        // Clean up
        URL.revokeObjectURL(url);
        document.body.removeChild(link);

        console.log("<<==  Downloaded ACTIVITY LOG successfully ==>>>");
      } catch (e) {
        console.error("Error in downloading file", e);
      }
    }
  };

  const downloadMaxPrepTxt = async () => {
    let { teamAplayerStats, teamBplayerStats } = GeneratePlayerStats(data);
    const dateX = moment(data.createdAt)
      .format("MM-D-YYYY, h:mm:ss a")
      .slice(0, 10);

    let dataExcludeTM = [];
    teamAplayerStats.map((v) => {
      if (v.jersey !== "-1" && v.player !== undefined) {
        dataExcludeTM.push(v);
      }
    });

    if (data) {
      let dataString =
        "\n" +
        "Jersey|Goals|Assists|TotalShots|ShotsOnGoal|GroundBalls|Turnovers|Takeaways|UnforcedErrors|FaceoffWon|FaceoffAttempts|MinutesPlayed|GoalsAgainst|Saves|ShutOuts|Wins|Losses|Ties|Penalties|PenaltyMinutes|PenaltySeconds\n";

      const data_exclude_TM_string = dataExcludeTM
        .map((val) => {
          if (val.jersey !== "-1") {
            return [
              `${val.jersey || ""}|${val.goals || ""}|${val.assists || ""}|${
                val.shotAttempts || ""
              }|${val.shotOG || ""}|${val.groundBall || ""}|${
                val.turnOver || val.faceoffsViolation
                  ? (val.turnOver || 0) + (val.faceoffsViolation || 0)
                  : ""
              }|${
                val.takeAway || val.causedTurnover
                  ? (val.takeAway || 0) + (val.causedTurnover || 0)
                  : ""
              }|${val.unforcedError || ""}|${val.faceoffsWon || ""}|${
                val.FaceoffAttempts || ""
              }||${val.goalsAgainst || ""}|${val.saves || ""}||||||||`,
            ];
          }
        })
        .filter(Boolean)
        .join("\n");

      dataString = dataString + data_exclude_TM_string + "\n";

      const played_in_game_string = playedIngameFilteredPlayers
        .map((val) => {
          if (val.jersey !== "-1") {
            return `${val.jersey}||||||||||||||||||`;
          }
        })
        .filter(Boolean)
        .join("\n");

      dataString = dataString + played_in_game_string;
      const val = [dataString];

      // Prepare file for download
      const headerString = "MAX.PREP \n";
      const fileContent = `${headerString}${val}`;
      const blob = new Blob([fileContent], {
        type: "text/plain;charset=utf-8",
      });

      // Create a link and trigger the download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${data.teamA.teamName}-maxPrep(${dateX})-(${data.teamB.teamName}).txt`;
      a.click();
      window.URL.revokeObjectURL(url); // Clean up
    }
  };

  const handleActivityLogDownload = async () => {
    await downloadActivityLog();
    toggleFileDownload(false);
    // toggleSuccessDownload();
  };

  const handleMaxPrepDownload = async () => {
    await downloadMaxPrepTxt();
    toggleFileDownload(false);
    // toggleSuccessDownload();
  };

  const handlePDFdownloadTeamSummary = async () => {
    const dateX = moment(data.createdAt)
      .format("MM-D-YYYY, h:mm:ss a")
      .slice(0, 10);
    try {
      const input = document.getElementById("team-summary");
      if (!input) {
        console.error("Element with ID 'team-summary' not found");
        return;
      }

      const dataUrl = await domtoimage.toPng(input);

      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (input.offsetHeight * imgWidth) / input.offsetWidth;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= 297;
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= 297;
      }

      pdf.save(
        `${data.teamA.teamName}-teamSummary-${dateX}-${data.teamB.teamName}.pdf`
      );
    } catch (error) {
      console.error("Error generating PDF", error);
    }
  };

  const handlePDFdownloadPlayerSummary = async () => {
    const dateX = moment(data.createdAt)
      .format("MM-D-YYYY, h:mm:ss a")
      .slice(0, 10);
    try {
      const input = document.getElementById("player-summary");
      if (!input) {
        console.error("Element with ID 'player-summary' not found");
        return;
      }

      const dataUrl = await domtoimage.toPng(input);

      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (input.offsetHeight * imgWidth) / input.offsetWidth;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= 297;
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= 297;
      }

      pdf.save(
        `${data.teamA.teamName}-player Summary-${dateX}-${data.teamB.teamName}.pdf`
      );
    } catch (error) {
      console.error("Error generating PDF", error);
    }
  };

  const handlePDFdownloadPlayerSummaryCombined = async () => {
    const dateX = moment(data.createdAt)
      .format("MM-D-YYYY, h:mm:ss a")
      .slice(0, 10);
    try {
      const input = document.getElementById("player-summary-combined");
      if (!input) {
        console.error("Element with ID 'player-summary' not found");
        return;
      }

      const dataUrl = await domtoimage.toPng(input);

      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (input.offsetHeight * imgWidth) / input.offsetWidth;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= 297;
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= 297;
      }

      pdf.save(
        `${data.teamA.teamName}-player Summary Combined-${dateX}-${data.teamB.teamName}.pdf`
      );
    } catch (error) {
      console.error("Error generating PDF", error);
    }
  };

  const handleDownloadForPlayer = () => {
    handlePDFdownloadPlayerSummary(); // First function
    handlePDFdownloadPlayerSummaryCombined(); // Second function
  };

  const toggleGameLogView = () => {
    setGameLogVisible(true); // Open Game Log
    setGameSummaryVisible(false); // Close Game Summary
    setPlayerSummaryVisible(false); // Close Player Summary
  };

  const toggleGameSummaryView = () => {
    setGameLogVisible(false); // Close Game Log
    setGameSummaryVisible(true); // Open Game Summary
    setPlayerSummaryVisible(false); // Close Player Summary
  };

  const togglePlayerSummaryView = () => {
    setGameLogVisible(false); // Close Game Log
    setGameSummaryVisible(false); // Close Game Summary
    setPlayerSummaryVisible(true); // Open Player Summary
  };

  const groupByUuid = (activityState) => {
    return activityState.reduce((acc, curr) => {
      (acc[curr.uuid] = acc[curr.uuid] || []).push(curr);
      return acc;
    }, {});
  };

  const groupedActivities = useMemo(
    () => groupByUuid(activityState),
    [activityState]
  );

  const getOrdinal = (period) => {
    const n = Number(period);
    if (n > 4) return "OT";
    if (!n) return period;
    const j = n % 10;
    const k = n % 100;
    if (j === 1 && k !== 11) return `${n}st`;
    if (j === 2 && k !== 12) return `${n}nd`;
    if (j === 3 && k !== 13) return `${n}rd`;
    return `${n}th`;
  };

  useEffect(() => {
    setActivityState(data?.activityLog || []);
  }, [data?.activityLog]);

  useEffect(() => {
    setPlayedIngameFilteredPlayers(
      data?.teamA.playedInGame.filter((player, index, arr) => {
        return (
          arr.findIndex((p) => p.jersey === player.jersey) ===
          arr.lastIndexOf(player)
        );
      })
    );
  }, [data]);

  const goBack = () => {
    history.goBack();
  };

  return (
    <div className="main">
      <div className="backBtn">
        <button className="actionButtonBack" onClick={goBack}>
          &larr;
        </button>
      </div>
      <h1 className="mainTitle" style={{ paddingTop: "0px" }}>
        GAME DETAILS
      </h1>

      {/* <div className="buttonContainer">
        
        <button
          className="actionButtonDel"
          //  onPress={toggleDelete}
        >
          delete
        </button>
      </div> */}

      <h2 className="teamNameHeading">{data?.teamA.teamName} </h2>
      <div className="headingBox">
        <div className="matchDetails">
          <div className="subHead">
            {moment(data?.general?.gameDate)
              .format("MM/DD/YYYY, h:mm:ss a")
              .slice(0, 10)}
            <p
              style={{
                color:
                  data?.teamA.status === "Won"
                    ? "#035909"
                    : data?.teamA.status === "Lost"
                    ? "#7c0303"
                    : "#0a2e5e",
              }}
            >
              {data?.teamA.status}
            </p>
            {data?.teamA?.goals}-{data?.teamB?.goals}
          </div>
          <div>
            <p style={{ color: "black", fontWeight: "700" }}>
              {data?.teamA.teamName === data?.general?.homeTeam?.teamName
                ? "VS"
                : "AT"}
            </p>
          </div>

          <div>
            <p style={{ color: "black", fontWeight: "900", fontSize: "21px" }}>
              {data?.teamB.teamName}
            </p>
            <p
              style={{
                color: "#0a2e5e",
                fontWeight: "700",
                marginBottom: "15px",
              }}
            >
              {data?.general?.conference ? "Conference Game" : "Non-Conference"}
            </p>
          </div>
        </div>
      </div>
      <div />

      <div className="headingBox">
        <div className="details">
          <div
            className="allBtnsContainer"
            style={{ display: "flex", margin: "15px 0", width: "100%" }}
          >
            <div className="row">
              <span className="txt">Game Log</span>
              <button className="dwnldBtn" onClick={handleActivityLogDownload}>
                <DownloadIcon style={{ color: "red", fontSize: 24 }} />
              </button>
              <button className="dwnldBtn" onClick={toggleGameLogView}>
                <VisibilityIcon style={{ color: "red", fontSize: 24 }} />
              </button>
            </div>

            <div className="row">
              <span className="txt">Game Summary</span>
              <button
                className="dwnldBtn"
                onClick={handlePDFdownloadTeamSummary}
              >
                <DownloadIcon style={{ color: "red", fontSize: 24 }} />
              </button>
              <button className="dwnldBtn" onClick={toggleGameSummaryView}>
                <VisibilityIcon style={{ color: "red", fontSize: 24 }} />
              </button>
            </div>

            <div className="row">
              <span className="txt">Player Summary</span>
              <button className="dwnldBtn" onClick={handleDownloadForPlayer}>
                <DownloadIcon style={{ color: "red", fontSize: 24 }} />
              </button>
              <button className="dwnldBtn" onClick={togglePlayerSummaryView}>
                <VisibilityIcon style={{ color: "red", fontSize: 24 }} />
              </button>
            </div>
            <div className="row">
              <span className="txt">MaxPrep Data</span>
              {data?.general?.playersStatsA === true ? (
                <button className="dwnldBtn" onClick={handleMaxPrepDownload}>
                  <DownloadIcon style={{ color: "red", fontSize: 24 }} />
                </button>
              ) : (
                <DownloadIcon style={{ color: "grey", fontSize: 24 }} />
              )}
            </div>
          </div>
          {gameLogVisible && (
            <>
              <p
                style={{
                  color: "black",
                  fontWeight: "700",
                  margin: "15px 0 15px 0",
                  fontSize: "26px",
                }}
              >
                GAME LOG
              </p>
              <div nestedScrollEnabled={true} style={{ margin: "5px 70px" }}>
                {Object.keys(groupedActivities).map((uuid, index) => (
                  <div key={uuid}>
                    {groupedActivities[uuid].map((activity, idx) => (
                      <div className="row" key={idx}>
                        <p className="activityTxtTeam">
                          {activity?.team ? `${activity.team} -` : ""}
                        </p>
                        <p className="activityTxtPeriod">
                          {activity?.period
                            ? `${getOrdinal(activity.period)} -`
                            : ""}
                        </p>
                        <p className="activityTxtTime">
                          {activity?.clockTime
                            ? ` ${activity.clockTime} -`
                            : ""}
                        </p>
                        <p
                          style={{ color: "red" }}
                          className="ActivityTxtStatement"
                        >
                          {activity?.statement && ` ${activity.statement}`}
                          {activity?.addDesc && ` - ${activity.addDesc}`}
                        </p>
                        <p className="activityTxtPlayer">
                          {activity?.jersey !== "-1" &&
                            activity?.jersey &&
                            `  #${activity.jersey}`}

                          {activity?.jersey !== "-1" &&
                            activity?.player &&
                            ` ${activity.player}`}
                        </p>
                        <p
                          style={{ color: "red" }}
                          className="ActivityTxtOther"
                        >
                          {activity?.otherTxt ? ` ${activity.otherTxt}` : ""}
                        </p>
                      </div>
                    ))}

                    {index < Object.keys(groupedActivities).length - 1 && (
                      <div className="divider" />
                    )}
                  </div>
                ))}

                {playedIngameFilteredPlayers?.map((val, index) => (
                  <p key={index} className="activityTxt">
                    {data?.teamA.teamName} -{" "}
                    <p style={{ color: "red" }}>Played In Game</p> - #
                    {val.jersey} {val.playerName}
                  </p>
                ))}
              </div>
            </>
          )}
          {gameSummaryVisible && (
            <div
              id="team-summary"
              style={{ padding: "20px", backgroundColor: "white" }}
            >
              <p
                style={{
                  color: "black",
                  fontWeight: "700",
                  margin: "15px 0 15px 0",
                  fontSize: "34px",
                }}
              >
                Game Summary
              </p>
              <p className="team-heading">
                {data.teamA.teamName}{" "}
                <span style={{ color: "#a8a845" }}> Vs </span>{" "}
                {data.teamB.teamName}
              </p>
              <div className="subHeadSummary">
                {moment(data?.general?.gameDate)
                  .format("MM/DD/YYYY, h:mm:ss a")
                  .slice(0, 10)}
                <p
                  style={{
                    color:
                      data?.teamA.status === "Won"
                        ? "#035909"
                        : data?.teamA.status === "Lost"
                        ? "#7c0303"
                        : "#0a2e5e",
                  }}
                >
                  {data?.teamA.status}
                </p>
                {data?.teamA?.goals}-{data?.teamB?.goals}
              </div>

              <div className="row-div-main-stat">
                <p className="team-sub-head" style={{ color: "#fff" }}>
                  SCORING
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  1st
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  2nd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  3rd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  4th
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  Total
                </p>
              </div>

              {/* <div className="stat-row-div">
                <p className="stat-heading">Goals</p>
              </div> */}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Shot Attempts
                </p>
                <p className="qtr-stat-box-grey">{A1?.shotAttempts ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.shotAttempts ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.shotAttempts ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.shotAttempts ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.shotAttempts ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.shotAttempts ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.shotAttempts ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.shotAttempts ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.shotAttempts ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.shotAttempts ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Shot On Goal</p>
                <p className="qtr-stat-box">{A1?.shotOnGoal ?? 0}</p>
                <p className="qtr-stat-box">{A2?.shotOnGoal ?? 0}</p>
                <p className="qtr-stat-box">{A3?.shotOnGoal ?? 0}</p>
                <p className="qtr-stat-box">{A4?.shotOnGoal ?? 0}</p>
                <p className="qtr-stat-box">{A?.shotOnGoal ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.shotOnGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.shotOnGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.shotOnGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.shotOnGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.shotOnGoal ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Shot Lost Possession
                </p>
                <p className="qtr-stat-box-grey">{A1?.shotLostPoss ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.shotLostPoss ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.shotLostPoss ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.shotLostPoss ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.shotLostPoss ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.shotLostPoss ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.shotLostPoss ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.shotLostPoss ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.shotLostPoss ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.shotLostPoss ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Shot Kept Possession</p>
                <p className="qtr-stat-box">{A1?.shotKeptPoss ?? 0}</p>
                <p className="qtr-stat-box">{A2?.shotKeptPoss ?? 0}</p>
                <p className="qtr-stat-box">{A3?.shotKeptPoss ?? 0}</p>
                <p className="qtr-stat-box">{A4?.shotKeptPoss ?? 0}</p>
                <p className="qtr-stat-box">{A?.shotKeptPoss ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.shotKeptPoss ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.shotKeptPoss ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.shotKeptPoss ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.shotKeptPoss ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.shotKeptPoss ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Goals
                </p>
                <p className="qtr-stat-box-grey">{A1?.goals ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.goals ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.goals ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.goals ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.goals ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.goals ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.goals ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.goals ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.goals ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.goals ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Assists</p>
                <p className="qtr-stat-box">{A1?.assists ?? 0}</p>
                <p className="qtr-stat-box">{A2?.assists ?? 0}</p>
                <p className="qtr-stat-box">{A3?.assists ?? 0}</p>
                <p className="qtr-stat-box">{A4?.assists ?? 0}</p>
                <p className="qtr-stat-box">{A?.assists ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.assists ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.assists ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.assists ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.assists ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.assists ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Man-up Opp
                </p>
                <p className="qtr-stat-box-grey">{A1?.manUpOpp ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.manUpOpp ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.manUpOpp ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.manUpOpp ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.manUpOpp ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.manUpOpp ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.manUpOpp ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.manUpOpp ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.manUpOpp ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.manUpOpp ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Man-up Goal</p>
                <p className="qtr-stat-box">{A1?.manUpGoal ?? 0}</p>
                <p className="qtr-stat-box">{A2?.manUpGoal ?? 0}</p>
                <p className="qtr-stat-box">{A3?.manUpGoal ?? 0}</p>
                <p className="qtr-stat-box">{A4?.manUpGoal ?? 0}</p>
                <p className="qtr-stat-box">{A?.manUpGoal ?? 0}</p>
              </div>

              {data?.general?.noneStatsB ? (
                <div>
                  <p>&nbsp;</p>
                </div>
              ) : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.manUpGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp"> {B2?.manUpGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.manUpGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.manUpGoal ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.manUpGoal ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div-main-stat">
                <p className="team-sub-head" style={{ color: "#fff" }}>
                  FIELDING
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  1st
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  2nd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  3rd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  4th
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  Total
                </p>
              </div>

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Ground Ball
                </p>
                <p className="qtr-stat-box-grey">{A1?.groundBall ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.groundBall ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.groundBall ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.groundBall ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.groundBall ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.groundBall ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.groundBall ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.groundBall ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.groundBall ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.groundBall ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Caused Turnover</p>
                <p className="qtr-stat-box">{A1?.causedTurnover ?? 0}</p>
                <p className="qtr-stat-box">{A2?.causedTurnover ?? 0}</p>
                <p className="qtr-stat-box">{A3?.causedTurnover ?? 0}</p>
                <p className="qtr-stat-box">{A4?.causedTurnover ?? 0}</p>
                <p className="qtr-stat-box">{A?.causedTurnover ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">
                      {B1?.causedTurnover ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">
                      {B2?.causedTurnover ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">
                      {B3?.causedTurnover ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">
                      {B4?.causedTurnover ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">{B?.causedTurnover ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Takeaway
                </p>
                <p className="qtr-stat-box-grey">{A1?.takeAway ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.takeAway ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.takeAway ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.takeAway ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.takeAway ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.takeAway ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.takeAway ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.takeAway ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.takeAway ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.takeAway ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Interception</p>
                <p className="qtr-stat-box">{A1?.interceptions ?? 0}</p>
                <p className="qtr-stat-box">{A2?.interceptions ?? 0}</p>
                <p className="qtr-stat-box">{A3?.interceptions ?? 0}</p>
                <p className="qtr-stat-box">{A4?.interceptions ?? 0}</p>
                <p className="qtr-stat-box">{A?.interceptions ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.interceptions ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.interceptions ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.interceptions ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.interceptions ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.interceptions ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Blocked Shot
                </p>
                <p className="qtr-stat-box-grey">{A1?.blockedShot ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.blockedShot ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.blockedShot ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.blockedShot ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.blockedShot ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.blockedShot ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.blockedShot ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.blockedShot ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.blockedShot ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.blockedShot ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Turnovers</p>
                <p className="qtr-stat-box">{A1?.turnOver ?? 0}</p>
                <p className="qtr-stat-box">{A2?.turnOver ?? 0}</p>
                <p className="qtr-stat-box">{A3?.turnOver ?? 0}</p>
                <p className="qtr-stat-box">{A4?.turnOver ?? 0}</p>
                <p className="qtr-stat-box">{A?.turnOver ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.turnOver ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.turnOver ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.turnOver ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.turnOver ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.turnOver ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Unforced Error
                </p>
                <p className="qtr-stat-box-grey">{A1?.unforcedError ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.unforcedError ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.unforcedError ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.unforcedError ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.unforcedError ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B1?.unforcedError ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B2?.unforcedError ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B3?.unforcedError ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B4?.unforcedError ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">{B?.unforcedError ?? 0}</p>
                  </div>
                </>
              )}

              {/* <div className="row-div">
                <p className="team-stat-box">Clears</p>
                <p className="qtr-stat-box">{A1?.clears ?? 0}</p>
                <p className="qtr-stat-box">{A2?.clears ?? 0}</p>
                <p className="qtr-stat-box">{A3?.clears ?? 0}</p>
                <p className="qtr-stat-box">{A4?.clears ?? 0}</p>
                <p className="qtr-stat-box">{A?.clears ?? 0}</p>
              </div>
              <div className="row-div">
                <p className="team-stat-box-opp">&nbsp;</p>
                <p className="qtr-stat-box-opp">{B1?.clears ?? 0}</p>
                <p className="qtr-stat-box-opp">{B2?.clears ?? 0}</p>
                <p className="qtr-stat-box-opp">{B3?.clears ?? 0}</p>
                <p className="qtr-stat-box-opp">{B4?.clears ?? 0}</p>
                <p className="qtr-stat-box-opp">{B?.clears ?? 0}</p>
              </div> */}

              <div className="row-div">
                <p className="team-stat-box">Clear Attempt</p>
                <p className="qtr-stat-box">{A1?.clearAttempt ?? 0}</p>
                <p className="qtr-stat-box">{A2?.clearAttempt ?? 0}</p>
                <p className="qtr-stat-box">{A3?.clearAttempt ?? 0}</p>
                <p className="qtr-stat-box">{A4?.clearAttempt ?? 0}</p>
                <p className="qtr-stat-box">{A?.clearAttempt ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.clearAttempt ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.clearAttempt ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.clearAttempt ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.clearAttempt ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.clearAttempt ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Clear Successful
                </p>
                <p className="qtr-stat-box-grey">{A1?.clearSuccess ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.clearSuccess ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.clearSuccess ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.clearSuccess ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.clearSuccess ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.clearSuccess ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.clearSuccess ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.clearSuccess ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.clearSuccess ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.clearSuccess ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Clear Failed</p>
                <p className="qtr-stat-box">{A1?.clearFailed ?? 0}</p>
                <p className="qtr-stat-box">{A2?.clearFailed ?? 0}</p>
                <p className="qtr-stat-box">{A3?.clearFailed ?? 0}</p>
                <p className="qtr-stat-box">{A4?.clearFailed ?? 0}</p>
                <p className="qtr-stat-box">{A?.clearFailed ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.clearFailed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.clearFailed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.clearFailed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.clearFailed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.clearFailed ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div-main-stat">
                <p className="team-sub-head" style={{ color: "#fff" }}>
                  FACEOFF
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  1st
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  2nd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  3rd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  4th
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  Total
                </p>
              </div>

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Faceoff Attempt
                </p>
                <p
                  className="qtr-stat-box-grey"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  {A1?.faceoffsAttempts ?? 0}
                </p>
                <p className="qtr-stat-box-grey">{A2?.faceoffsAttempts ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.faceoffsAttempts ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.faceoffsAttempts ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.faceoffsAttempts ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B1?.faceoffsAttempts ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B2?.faceoffsAttempts ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B3?.faceoffsAttempts ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B4?.faceoffsAttempts ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B?.faceoffsAttempts ?? 0}
                    </p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Draw Control</p>
                <p className="qtr-stat-box">{A1?.drawControl ?? 0}</p>
                <p className="qtr-stat-box">{A2?.drawControl ?? 0}</p>
                <p className="qtr-stat-box">{A3?.drawControl ?? 0}</p>
                <p className="qtr-stat-box">{A4?.drawControl ?? 0}</p>
                <p className="qtr-stat-box">{A?.drawControl ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.drawControl ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.drawControl ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.drawControl ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.drawControl ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.drawControl ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Faceoff Won
                </p>
                <p className="qtr-stat-box-grey">{A1?.faceoffsWon ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.faceoffsWon ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.faceoffsWon ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.faceoffsWon ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.faceoffsWon ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.faceoffsWon ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.faceoffsWon ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.faceoffsWon ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.faceoffsWon ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.faceoffsWon ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Draw Lost</p>
                <p className="qtr-stat-box">{A1?.drawLost ?? 0}</p>
                <p className="qtr-stat-box">{A2?.drawLost ?? 0}</p>
                <p className="qtr-stat-box">{A3?.drawLost ?? 0}</p>
                <p className="qtr-stat-box">{A4?.drawLost ?? 0}</p>
                <p className="qtr-stat-box">{A?.drawLost ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.drawLost ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.drawLost ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.drawLost ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.drawLost ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.drawLost ?? 0}</p>
                  </div>
                </>
              )}
              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Faceoff Lost
                </p>
                <p className="qtr-stat-box-grey">{A1?.faceoffLost ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.faceoffLost ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.faceoffLost ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.faceoffLost ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.faceoffLost ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">{B1?.faceoffLost ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B2?.faceoffLost ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B3?.faceoffLost ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B4?.faceoffLost ?? 0}</p>
                    <p className="qtr-stat-box-grey">{B?.faceoffLost ?? 0}</p>
                  </div>
                </>
              )}
              <div className="row-div">
                <p className="team-stat-box">F/O Ground Ball</p>
                <p className="qtr-stat-box">{A1?.faceoffGB ?? 0}</p>
                <p className="qtr-stat-box">{A2?.faceoffGB ?? 0}</p>
                <p className="qtr-stat-box">{A3?.faceoffGB ?? 0}</p>
                <p className="qtr-stat-box">{A4?.faceoffGB ?? 0}</p>
                <p className="qtr-stat-box">{A?.faceoffGB ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.faceoffGB ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.faceoffGB ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.faceoffGB ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.faceoffGB ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.faceoffGB ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Faceoff Violation
                </p>
                <p className="qtr-stat-box-grey">
                  {A1?.faceoffViolations ?? 0}
                </p>
                <p className="qtr-stat-box-grey">
                  {A2?.faceoffViolations ?? 0}
                </p>
                <p className="qtr-stat-box-grey">
                  {A3?.faceoffViolations ?? 0}
                </p>
                <p className="qtr-stat-box-grey">
                  {A4?.faceoffViolations ?? 0}
                </p>
                <p className="qtr-stat-box-grey">{A?.faceoffViolations ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{
                        backgroundColor: "rgb(212, 211, 211)",
                      }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B1?.faceoffViolations ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B2?.faceoffViolations ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B3?.faceoffViolations ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B4?.faceoffViolations ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B?.faceoffViolations ?? 0}
                    </p>
                  </div>
                </>
              )}

              <div className="row-div-main-stat">
                <p className="team-sub-head" style={{ color: "#fff" }}>
                  GOAL TENDING
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  1st
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  2nd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  3rd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  4th
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  Total
                </p>
              </div>

              <div className="row-div">
                <p className="team-stat-box">SOG/SAVES</p>
                <p className="qtr-stat-box">
                {A1?.shotOG ?? 0}/{A1?.saves ?? 0}{" "} 
                {A1?.shotOG > 0 ? ((A1?.saves ?? 0) / (A1?.shotOG) * 100).toFixed(1) : '0.0'}%
                </p>
                <p className="qtr-stat-box">
                {A2?.shotOG ?? 0}/{A2?.saves ?? 0}{" "} 
                {A2?.shotOG > 0 ? ((A2?.saves ?? 0) / (A2?.shotOG) * 100).toFixed(1) : '0.0'}%
                </p>
                <p className="qtr-stat-box">
                {A3?.shotOG ?? 0}/{A3?.saves ?? 0}{" "} 
                {A3?.shotOG > 0 ? ((A3?.saves ?? 0) / (A3?.shotOG) * 100).toFixed(1) : '0.0'}%
                </p>
                <p className="qtr-stat-box">
                {A4?.shotOG ?? 0}/{A4?.saves ?? 0}{" "} 
                {A4?.shotOG > 0 ? ((A4?.saves ?? 0) / (A4?.shotOG) * 100).toFixed(1) : '0.0'}%
                </p>
                <p className="qtr-stat-box">
                {A?.shotOG ?? 0}/{A?.saves ?? 0}{" "}
                {A?.shotOG > 0 ? ((A?.saves ?? 0) / (A?.shotOG) * 100).toFixed(1) : '0.0'}%
                </p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">
                    {B1?.shotOG ?? 0}/{B1?.saves ?? 0}{" "} 
                    {B1?.shotOG > 0 ? ((B1?.saves ?? 0) / (B1?.shotOG) * 100).toFixed(1) : '0.0'}%
                    </p>
                    <p className="qtr-stat-box-opp">
                    {B2?.shotOG ?? 0}/{B2?.saves ?? 0}{" "} 
                    {B2?.shotOG > 0 ? ((B2?.saves ?? 0) / (B2?.shotOG) * 100).toFixed(1) : '0.0'}%
                    </p>
                    <p className="qtr-stat-box-opp">
                    {B3?.shotOG ?? 0}/{B3?.saves ?? 0}{" "} 
                    {B3?.shotOG > 0 ? ((B3?.saves ?? 0) / (B3?.shotOG) * 100).toFixed(1) : '0.0'}%
                    </p>
                    <p className="qtr-stat-box-opp">
                    {B4?.shotOG ?? 0}/{B4?.saves ?? 0}{" "} 
                    {B4?.shotOG > 0 ? ((B4?.saves ?? 0) / (B4?.shotOG) * 100).toFixed(1) : '0.0'}%
                    </p>
                    <p className="qtr-stat-box-opp">
                    {B?.shotOG ?? 0}/{B?.saves ?? 0}{" "} 
                    {B?.shotOG > 0 ? ((B?.saves ?? 0) / (B?.shotOG) * 100).toFixed(1) : '0.0'}%
                    </p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Save Controlled
                </p>
                <p className="qtr-stat-box-grey">{A1?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box-grey">{A2?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box-grey">{A3?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box-grey">{A4?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box-grey">{A?.saveControlled ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B1?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B2?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B3?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B4?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B?.saveControlled ?? 0}
                    </p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Save Controlled</p>
                <p className="qtr-stat-box">{A1?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box">{A2?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box">{A3?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box">{A4?.saveControlled ?? 0}</p>
                <p className="qtr-stat-box">{A?.saveControlled ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">
                      {B1?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">
                      {B2?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">
                      {B3?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">
                      {B4?.saveControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-opp">{B?.saveControlled ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p
                  className="team-stat-box"
                  style={{ backgroundColor: "rgb(212, 211, 211)" }}
                >
                  Save Not Controlled
                </p>
                <p className="qtr-stat-box-grey">
                  {A1?.saveNotControlled ?? 0}
                </p>
                <p className="qtr-stat-box-grey">
                  {A2?.saveNotControlled ?? 0}
                </p>
                <p className="qtr-stat-box-grey">
                  {A3?.saveNotControlled ?? 0}
                </p>
                <p className="qtr-stat-box-grey">
                  {A4?.saveNotControlled ?? 0}
                </p>
                <p className="qtr-stat-box-grey">{A?.saveNotControlled ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p
                      className="team-stat-box-opp"
                      style={{ backgroundColor: "rgb(212, 211, 211)" }}
                    >
                      &nbsp;
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B1?.saveNotControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B2?.saveNotControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B3?.saveNotControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B4?.saveNotControlled ?? 0}
                    </p>
                    <p className="qtr-stat-box-grey">
                      {B?.saveNotControlled ?? 0}
                    </p>
                  </div>
                </>
              )}

              <div className="row-div">
                <p className="team-stat-box">Goal Allowed</p>
                <p className="qtr-stat-box">{A1?.goalAllowed ?? 0}</p>
                <p className="qtr-stat-box">{A2?.goalAllowed ?? 0}</p>
                <p className="qtr-stat-box">{A3?.goalAllowed ?? 0}</p>
                <p className="qtr-stat-box">{A4?.goalAllowed ?? 0}</p>
                <p className="qtr-stat-box">{A?.goalAllowed ?? 0}</p>
              </div>
              {data?.general?.noneStatsB ? null : (
                <>
                  <div className="row-div">
                    <p className="team-stat-box-opp">&nbsp;</p>
                    <p className="qtr-stat-box-opp">{B1?.goalAllowed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B2?.goalAllowed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B3?.goalAllowed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B4?.goalAllowed ?? 0}</p>
                    <p className="qtr-stat-box-opp">{B?.goalAllowed ?? 0}</p>
                  </div>
                </>
              )}

              <div className="row-div-main-stat">
                <p className="team-sub-head" style={{ color: "#fff" }}>
                  PENALTIES
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  1st
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  2nd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  3rd
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  4th
                </p>
                <p className="qtr-sub-head" style={{ color: "#fff" }}>
                  Total
                </p>
              </div>
            </div>
          )}

          {playerSummaryVisible && (
            <div
              id="player-summary"
              style={{ padding: "20px", backgroundColor: "white" }}
            >
              <p
                style={{
                  color: "red",
                  fontWeight: "700",
                  margin: "15px 0",
                  fontSize: "34px",
                }}
              >
                PLAYER SUMMARY
              </p>
              <p className="team-heading">
                {data.teamA.teamName}{" "}
                <span style={{ color: "#a8a845" }}>Vs</span>{" "}
                {data.teamB.teamName}
              </p>
              <div className="subHeadSummary">
                {moment(data?.general?.gameDate)
                  .format("MM/DD/YYYY, h:mm:ss a")
                  .slice(0, 10)}
                <p
                  style={{
                    color:
                      data?.teamA.status === "Won"
                        ? "#035909"
                        : data?.teamA.status === "Lost"
                        ? "#7c0303"
                        : "#0a2e5e",
                  }}
                >
                  {data?.teamA.status}
                </p>
                {data?.teamA?.goals}-{data?.teamB?.goals}
              </div>

              {/* Team A Section Tables */}
              {/* <h2>Team A Player Stats</h2> */}
              {Object.keys(sections).map((section) => (
                <div key={section}>
                  <h1 className="sectionHeading">{section}</h1>
                  {renderTable(teamAplayerStats, section, sections[section])}
                </div>
              ))}
            </div>
          )}

          {playerSummaryVisible && (
            <div
              id="player-summary-combined"
              style={{ padding: "20px", backgroundColor: "white" }}
            >
              <p
                style={{
                  color: "red",
                  fontWeight: "700",
                  margin: "15px 0",
                  fontSize: "34px",
                }}
              >
                PLAYER SUMMARY COMBINED STATS
              </p>
              <p className="team-heading">
                {data.teamA.teamName}{" "}
                <span style={{ color: "#a8a845" }}>Vs</span>{" "}
                {data.teamB.teamName}
              </p>
              <div className="subHeadSummary">
                {moment(data?.general?.gameDate)
                  .format("MM/DD/YYYY, h:mm:ss a")
                  .slice(0, 10)}
                <p
                  style={{
                    color:
                      data?.teamA.status === "Won"
                        ? "#035909"
                        : data?.teamA.status === "Lost"
                        ? "#7c0303"
                        : "#0a2e5e",
                  }}
                >
                  {data?.teamA.status}
                </p>
                {data?.teamA?.goals}-{data?.teamB?.goals}
              </div>

              {/* Flex container for sections */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  margin: "0",
                  padding: "0",
                }}
              >
                <div style={{ flex: "1 0 25%", margin: "0", padding: "0" }}>
                  {/* <h1 className="sectionHeading" style={{ margin: '0' }}>{section}</h1> */}
                  {renderTableWithTotals(teamAplayerStats)}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* {delIsVisible && (
        <DeleteOverlay
          isVisible={delIsVisible}
          onBackdropPress={() => toggleDelete(false)}
          navigation={props.navigation}
          handleDelete={handleDelete}
          loading={loading}
        />
      )}
      {visible && (
        <SuccessOverlay
          onBackdropPress={() => toggleSuccessDownload(false)}
          isVisible={visible}
          type="File download has started!"
          noTick={true}
        />
      )}
      {delSuccessVisible && (
        <SuccessOverlay
          onBackdropPress={() => toggleDelSuccessModal(false)}
          isVisible={delSuccessVisible}
          type="Game has been deleted successfully!"
          noTick={true}
        />
      )} */}
    </div>
  );
};

export default GameLogDetails;
